import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { ProductCode, ProductPrice, SuperCodeDisplay } from '../../../../components';
import { getProductDescription } from '../../../../util';
import { translate } from '../../../../services';

export class Header extends Component {
  render() {
    const { product, showConfiguratorButtonAtTop, additionalProduct, properties, customClassName, supercode, supercodeAdditionalProduct, isReadyAssembled, productModelType } = this.props;
    const headerDescription = additionalProduct?.properties.any(p=>p.name=="dummyCode")?getProductDescription(product):product && product.code && product.code?.startsWith('V')?getProductDescription(product):getProductDescription(product);
    const supercodeToDisplay = supercodeAdditionalProduct ? supercode + ' + ' + supercodeAdditionalProduct: supercode;
    
    return <div className={"configurator-header " + customClassName}>
      <div className="configurator-header-description" style={showConfiguratorButtonAtTop ? {width: "55%"}:{}}>
        <span>{ headerDescription }</span>
        { properties && properties.orderCodeAvailable && 
        <span className="code-request">
          Part number:&nbsp;
          <ProductCode { ...product } code={ product.aliases ? product.aliases.usConCode : product.code }/>
        </span> }
        <span>
          <SuperCodeDisplay isReadyAssembled= { isReadyAssembled } supercode ={ supercodeToDisplay } supercodeAdditionalProduct = {supercodeAdditionalProduct}/>
        </span>
      </div>
      <div style={showConfiguratorButtonAtTop ? {width: "40%"}:{}}>
        <ProductPrice translationPhrase={'MainProduct_'} showConfiguratorButtonAtTop={showConfiguratorButtonAtTop} fromConfigHeader priceSize='big' product={ product } additionalProduct={ [additionalProduct] } />
      </div>
    </div>;
  }
}

Header.propTypes = {
  product: PropTypes.shape( {
    description: PropTypes.string.isRequired
  } ),
  properties: PropTypes.shape( {
    orderCodeAvailable: PropTypes.bool
  } ),
  supercode: PropTypes.string,
  isReadyAssembled: PropTypes.bool,
  productModelType: PropTypes.number
};